import {
  parsePermissions,
  hasPermission,
  getAllPermissionKeys,
  isSystemAdministratorRole,
  getSessionRoleName,
} from "../../../utils/permissionUtils";
import { canCreateCapaRecord } from "../capa/capaAccess";

export function useScheduleAccess(userData) {
  const isSystemAdmin = isSystemAdministratorRole(getSessionRoleName(userData));
  const perms = isSystemAdmin
    ? getAllPermissionKeys()
    : parsePermissions(userData?.Permission);

  const canAddEditSchedule =
    isSystemAdmin || hasPermission(perms, "ADD_EDIT_SCHEDULE");
  const canViewStudyList =
    isSystemAdmin || hasPermission(perms, "STUDY_LIST");
  const canCreateCapa = canCreateCapaRecord({
    userData,
    isSystemAdmin,
    permissions: perms,
  });

  return {
    isSystemAdmin,
    canAddEditSchedule,
    canViewStudyList,
    canCreateCapa,
  };
}
